import { Box } from '@mui/material';

import { HEADER_TITLE } from '@/constants/layout';

/**
 * This component is a placeholder (slot) to render Header Title later via React Portal.
 */
const Title = () => {
  return <Box id={HEADER_TITLE} data-testid="headerTitle"></Box>;
};

export default Title;
